export const PROCESSES = [
  "Arc Spray",
  "Flame Spray",
  "HVOF",
  "HVOLF",
  "Plasma Spray",
  "Cold Spray",
  "Suspension Plasma Spray",
];

export const CATEGORIES = ["Metal", "Ceramic", "Cermet", "Composite", "MMC", "Polymer", "Other"];

export const CATEGORY_COLORS = {
  Metal: "text-secondary border-secondary/40 bg-secondary/10",
  Ceramic: "text-primary border-primary/40 bg-primary/10",
  Cermet: "text-amber-400 border-amber-400/40 bg-amber-400/10",
  Composite: "text-emerald-400 border-emerald-400/40 bg-emerald-400/10",
  MMC: "text-purple-400 border-purple-400/40 bg-purple-400/10",
  Polymer: "text-pink-400 border-pink-400/40 bg-pink-400/10",
  Other: "text-muted-foreground border-border bg-muted",
};

export const heroImg =
  "https://images.unsplash.com/photo-1711418235334-8895331a6cf9?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NTYxNzV8MHwxfHNlYXJjaHwyfHx0aGVybWFsJTIwcGxhc21hJTIwc3ByYXklMjBjb2F0aW5nJTIwaW5kdXN0cnl8ZW58MHx8fHwxNzg2MTkxNjc3fDA&ixlib=rb-4.1.0&q=85";
